<div class="mobile-app-promo">
  <button mat-icon-button class="close-btn" (click)="close()" aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>

  <div class="promo-content">
    <mat-icon class="phone-icon">phone_iphone</mat-icon>

    <h2>{{ 'mobileAppPromo.title' | translate }}</h2>
    <p>{{ 'mobileAppPromo.description' | translate }}</p>

    <div class="store-buttons">
      <a class="store-btn" [href]="appStoreUrl" target="_blank" rel="noopener noreferrer">
        <mat-icon>phone_iphone</mat-icon>
        <span class="store-btn__labels">
          <small>{{ 'mobileAppPromo.downloadOn' | translate }}</small>
          <strong>{{ 'mobileAppPromo.appStore' | translate }}</strong>
        </span>
      </a>

      <a class="store-btn" [href]="playStoreUrl" target="_blank" rel="noopener noreferrer">
        <mat-icon>android</mat-icon>
        <span class="store-btn__labels">
          <small>{{ 'mobileAppPromo.getItOn' | translate }}</small>
          <strong>{{ 'mobileAppPromo.googlePlay' | translate }}</strong>
        </span>
      </a>
    </div>
  </div>
</div>
